import { render, staticRenderFns } from "./DetailCommande.vue?vue&type=template&id=c16a694a&"
import script from "./DetailCommande.vue?vue&type=script&lang=js&"
export * from "./DetailCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16a694a')) {
      api.createRecord('c16a694a', component.options)
    } else {
      api.reload('c16a694a', component.options)
    }
    module.hot.accept("./DetailCommande.vue?vue&type=template&id=c16a694a&", function () {
      api.rerender('c16a694a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commandes/DetailCommande.vue"
export default component.exports